import { TestIdDomain } from 'constants/testIds';

const VendorRequestsTestIdsScope = {
  DETAIL_DRAWER: 'vendor-request-drawer',
};

export const VendorRequestsTestIds = {
  REQUEST_TYPE_INPUT: `${TestIdDomain.VENDOR_REQUESTS}.request-type-input`,
  VENDOR_NAME_INPUT: `${TestIdDomain.VENDOR_REQUESTS}.vendor-name-input`,
  STATUS_SELECT: `${TestIdDomain.VENDOR_REQUESTS}.status-select`,
  CREATED_AFTER_DATE: `${TestIdDomain.VENDOR_REQUESTS}.created-after-date`,
  CREATED_BEFORE_DATE: `${TestIdDomain.VENDOR_REQUESTS}.created-before-date`,
  GROUP_ROW: `${TestIdDomain.VENDOR_REQUESTS}.group-row`,
  DETAIL_DRAWER: `${TestIdDomain.VENDOR_REQUESTS}.${VendorRequestsTestIdsScope.DETAIL_DRAWER}`,
  ITEMS_OPERATION_INPUT: `${VendorRequestsTestIdsScope.DETAIL_DRAWER}.items-operation-input`,
  ITEMS_STATUS_SELECT: `${VendorRequestsTestIdsScope.DETAIL_DRAWER}.items-status-select`,
  ITEMS_VENDOR_REQUEST_ID_INPUT: `${VendorRequestsTestIdsScope.DETAIL_DRAWER}.items-vendor-request-id-input`,
  GROUP_ITEM_COUNT: `${VendorRequestsTestIdsScope.DETAIL_DRAWER}.group-item-count`,
  GROUP_DURATION: `${VendorRequestsTestIdsScope.DETAIL_DRAWER}.group-duration`,
  ITEM_ACCORDION: `${VendorRequestsTestIdsScope.DETAIL_DRAWER}.item-accordion`,
  ITEMS_LIST: `${VendorRequestsTestIdsScope.DETAIL_DRAWER}.items-list`,
  ITEMS_LOADING: `${VendorRequestsTestIdsScope.DETAIL_DRAWER}.items-loading`,
  ITEMS_EMPTY: `${VendorRequestsTestIdsScope.DETAIL_DRAWER}.items-empty`,
  ITEMS_ERROR: `${VendorRequestsTestIdsScope.DETAIL_DRAWER}.items-error`,
  LOAD_MORE_BUTTON: `${VendorRequestsTestIdsScope.DETAIL_DRAWER}.load-more-button`,
  REQUEST_DOWNLOAD_BUTTON: `${VendorRequestsTestIdsScope.DETAIL_DRAWER}.request-download-button`,
  RESPONSE_DOWNLOAD_BUTTON: `${VendorRequestsTestIdsScope.DETAIL_DRAWER}.response-download-button`,
  REQUEST_REVEAL_BUTTON: `${VendorRequestsTestIdsScope.DETAIL_DRAWER}.request-reveal-button`,
  RESPONSE_REVEAL_BUTTON: `${VendorRequestsTestIdsScope.DETAIL_DRAWER}.response-reveal-button`,
};
